module.exports = __webpack_public_path__ + "img/combine-pdf.47ade9b0.svg";